var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileSystemMessageActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.57812V15.8182C4 16.3968 4.24082 16.9518 4.66947 17.3609C5.09812 17.7701 5.67951 18 6.28571 18H17.7143C18.3205 18 18.9019 17.7701 19.3305 17.3609C19.7592 16.9518 20 16.3968 20 15.8182V9.57812L13.1977 13.5731C12.8375 13.7846 12.4229 13.8966 12 13.8966C11.5771 13.8966 11.1625 13.7846 10.8023 13.5731L4 9.57812Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.29674V8.18183C20 7.60317 19.7592 7.04822 19.3305 6.63904C18.9019 6.22987 18.3205 6 17.7143 6H6.28571C5.67951 6 5.09812 6.22987 4.66947 6.63904C4.24082 7.04822 4 7.60317 4 8.18183V8.29674L11.4011 12.6444C11.5812 12.7502 11.7885 12.8062 12 12.8062C12.2115 12.8062 12.4188 12.7502 12.5989 12.6444L20 8.29674Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSystemMessageActive);
export default __webpack_public_path__ + "static/media/MobileSystemMessageActive.df11ca5d00fd38ccd910e25f6db4dffb.svg";
export { ForwardRef as ReactComponent };